export default __webpack_public_path__ + "static/media/logout.c87dd323.svg";